<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="关键字">
                    <el-input v-model="query.keyword" placeholder="请输入心愿标题"></el-input>
                </el-form-item>
<!--                <el-form-item label="类型">-->
<!--                    <el-select v-model="query.question_type" placeholder="全部" clearable>-->
<!--                        <el-option v-for="(item, index) in question_type_array" :label="item" :value="index" :key="index"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="认领时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="claim_id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="wish" label="心愿标题">
                        <template slot-scope="scope">
                            {{ scope.row.wish ?  scope.row.wish.title : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="user" label="认领人号码" width="130">
                        <template slot-scope="scope">
                            {{ scope.row.claimUser ?  scope.row.claimUser.mobile : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="user" label="认领人" width="200">
                        <template slot-scope="scope">
                            {{ scope.row.claimUser ?  scope.row.claimUser.nickName : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="认领时间" width="150"></el-table-column>
<!--                    <el-table-column fixed="right" label="操作" width="100">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/question/edit'">编辑</el-button>-->
<!--                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/question/del'">删除</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import {wishClaim } from '@/api/education';

    export default {
        components: {
            /*编辑组件*/
            // Add
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                query: {
                    question_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                question_type_array: [],
                import_true: false
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                wishClaim(this.query).then((result)=>{
                    this.loading = false
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },


            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/wish/claim/index.vue